import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    $(this.element).daterangepicker({
      opens: 'right',
      timePicker: true,
      applyButtonClasses: "bg-purple-dark text-white rounded-md",
      cancelButtonClasses: "text-purple-dark",
      locale: {
        format: "DD-MM-YYYY h:mma"
      }
    }, function(start, end) {
      $("#campaign_start_at").val(start.format("DD-MM-YYYY HH:mm:ss"));
      $("#campaign_end_at").val(end.format("DD-MM-YYYY HH:mm:ss"));
    });
  }
}
